import { createContext, useContext, useState, ReactNode } from 'react';

const RefreshContext = createContext({ refresh: 0, triggerRefresh: () => {} });

export function RefreshProvider({ children }: { children: ReactNode }) {
  const [refresh, setRefresh] = useState(0);
  const triggerRefresh = () => setRefresh(r => r + 1);
  return (
    <RefreshContext.Provider value={{ refresh, triggerRefresh }}>
      {children}
    </RefreshContext.Provider>
  );
}

export function useRefresh() {
  return useContext(RefreshContext);
} 